export const checkDate = ({ id, value }, state) => {
  const dateWages = new Date().setFullYear(
    id === "firstDateWagesYear" ? value : state.firstDateWagesYear,
    id === "firstDateWagesMonth" ? value - 1 : state.firstDateWagesMonth - 1,
    id === "firstDateWagesDay" ? value : state.firstDateWagesDay
  );
  const startDate = new Date().setFullYear(
    id === "startDateYear" ? value : state.startDateYear,
    id === "startDateMonth" ? value - 1 : state.startDateMonth - 1,
    id === "startDateDay" ? value : state.startDateDay
  );
  const oneYr = new Date().setFullYear(new Date().getFullYear() + 1);

  return dateWages <= oneYr && startDate <= dateWages;
};
